import React from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import { useMediaQuery, useTheme } from "@mui/material";

import RoundImage from "../others/RoundImage";

const TestimonialListItem: React.FC<ITestimonialListItemProps> = ({
  name,
  title,
  image,
  description,
  imageAlt,
}) => {
  const theme = useTheme();
  const isDownSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        width: 344,
        height: 392,
        margin: theme.spacing(4, "auto"),
        borderRadius:"10px",
        boxShadow: "2px 2px 4px rgba(68, 68, 68, 0.15)",
        [theme.breakpoints.down("sm")]: {
          width: 300,
          height: 358,
        },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", pb: 1 }}>
          <RoundImage
            src={image}
            alt={imageAlt}
            imageProps={{
              width: isDownSm ? 50 : 100,
              height: isDownSm ? 50 : 100,
            }}
            boxProps={{
              width: isDownSm ? 50 : 100,
              height: isDownSm ? 50 : 100,
            }}
          />
        </Box>
        <Typography align="center" variant={isDownSm ? "subtitle2" : "h6"}>
          {name}
        </Typography>
        <Typography variant="body2" align="center" color="textSecondary">
          {title}
        </Typography>
        <Box mt={4}>
          <Typography variant="body1" align="justify">
            {description}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TestimonialListItem;
